import { getUserWidgetPreviewRecords } from './processWidgetData'

const LOCAL_PREVIEW_ROUTE_ROLES = {
    operations: 'veterinarian',
    orders: 'horseBreeder',
}

export const getLocalPreviewUserTypeForRoute = route => {
    return LOCAL_PREVIEW_ROUTE_ROLES[route] || null
}

export const getLocalPreviewUserRouteRecords = ({
    records = [],
    route,
    userId,
    limit = 10,
}) => {
    const userType = getLocalPreviewUserTypeForRoute(route)
    if (!userType) return []

    const contractRecords = records.filter(record => {
        return record?.values?.lastFollowUpResult === 'قرارداد'
    })

    return getUserWidgetPreviewRecords({
        records: contractRecords,
        userType,
        userId,
        limit,
    })
}

export const createLocalPreviewUserPage = page => {
    if (!page) return page

    const statusActions = Object.fromEntries(
        Object.entries(page.actions || {}).filter(([, action]) => {
            return action?.function === 'openStatusModal'
        })
    )

    return {
        ...page,
        actions: statusActions,
        addNew: -1,
        noAddNew: true,
        hideAddButton: true,
        hideFilter: true,
        extra: undefined,
        fetchUrl: undefined,
        addUrl: undefined,
        editUrl: undefined,
        removeUrl: undefined,
    }
}
